import { ReactNode } from 'react';
import styled from 'styled-components';

import { useNonAmpUrl } from 'hooks/useNonAmpUrl';
import { useAmpContext } from 'utils/AmpContext';

const SlideshowButtonWrapperAnchor = styled.a`
  display: flex;
  width: 100%;
  height: 100%;

  > * {
    pointer-events: none;
  }
`;

type Props = {
  carouselId: string;
  children: ReactNode;
};

/*
 * Click actions don't work on AMP - redirect the user to outside of AMP upon
 * clicking on a slide.
 */
export function SlideshowAmpButtonWrapper({ carouselId, children }: Props) {
  const nonAmpUrl = useNonAmpUrl();
  const isAmp = useAmpContext();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!isAmp) return <>{children}</>;

  return (
    <SlideshowButtonWrapperAnchor href={`${nonAmpUrl}#${carouselId}`}>
      {children}
    </SlideshowButtonWrapperAnchor>
  );
}
